<template>
  	<div>
		<div class="page-wrapper introducer l-pb-80">
			<div class="introducer__content">
				<h1 class="introducer__title" v-html="$t('introducerText1')"></h1>
				<h2 class="introducer__subtitle" v-html="$t('introducerSubtitle')"></h2>
				<p class="introducer__text">{{ $t('introducerText2') }}</p>
				<a v-if="$i18n.locale != 'fr-CA'" class="play" href="#" @click="toggleYoutubeVideoPopup($t('videoYoutubeId'), 1120, 630)">
					<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 142.448 142.448" style="enable-background:new 0 0 142.448 142.448;" xml:space="preserve"> <g> <path style="fill:#1D1D1B;" d="M142.411,68.9C141.216,31.48,110.968,1.233,73.549,0.038c-20.361-0.646-39.41,7.104-53.488,21.639 C6.527,35.65-0.584,54.071,0.038,73.549c1.194,37.419,31.442,67.667,68.861,68.861c0.779,0.025,1.551,0.037,2.325,0.037 c19.454,0,37.624-7.698,51.163-21.676C135.921,106.799,143.033,88.377,142.411,68.9z M111.613,110.336 c-10.688,11.035-25.032,17.112-40.389,17.112c-0.614,0-1.228-0.01-1.847-0.029c-29.532-0.943-53.404-24.815-54.348-54.348 c-0.491-15.382,5.122-29.928,15.806-40.958c10.688-11.035,25.032-17.112,40.389-17.112c0.614,0,1.228,0.01,1.847,0.029 c29.532,0.943,53.404,24.815,54.348,54.348C127.91,84.76,122.296,99.306,111.613,110.336z"/> <path style="fill:#1D1D1B;" d="M94.585,67.086L63.001,44.44c-3.369-2.416-8.059-0.008-8.059,4.138v45.293 c0,4.146,4.69,6.554,8.059,4.138l31.583-22.647C97.418,73.331,97.418,69.118,94.585,67.086z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
					{{ $t('general.watchVideo') }}
				</a>
				<p v-if="$i18n.locale == 'fr-CA'"><br></p>
				<div class="introducer__applications">
					<div class="introducer__application"><a :href="$t('general.appStoreLink')" target="_blank"><img :src="require('@/' + $t('general.appStoreImage'))" alt="" style="height: 50px;"/></a></div>
					<div class="introducer__application"><a :href="$t('general.googleStoreLink')" target="_blank"><img :src="require('@/' + $t('general.googleStoreImage'))" alt="" style="height: 50px;"/></a></div>
				</div>
				<p class="introducer__conditions">{{ $t('availabilityCondition') }}</p>
			</div>
			<div><img :src="require('@/' + $t('introducerImage'))" alt="" class="introducer__image" /></div>
		</div>
		<showcaser class="page-wrapper l-pb-80" :items="$t('keyFeatures.items')">
			<h1 class="showcaser-title">{{ $t('keyFeatures.title') }}</h1>
			<p class="showcase-text" v-html="$t('keyFeatures.subtitle')"></p>
		</showcaser>
		<div class="page-wrapper introducer l-pb-80">
			<div class="introducer__content">
				<h1 class="introducer__title">{{ $t('integrations.title') }}</h1>
				<p class="introducer__text" v-html="$t('integrations.text')"></p>
			</div>
			<div><img :src="require('@/' + $t('integrations.image'))" alt="" class="introducer__image introducer__image--small" /></div>
		</div>
		<div class="page-wrapper introducer introducer--reversed l-pb-80">
			<div class="introducer__content">
				<h1 class="introducer__title">{{ $t('collaboration.title') }}</h1>
				<p class="introducer__text" v-html="$t('collaboration.text')"></p>
			</div>
			<div><img :src="require('@/' + $t('collaboration.image'))"  alt="" class="introducer__image introducer__image--small" /></div>
		</div>	
		<div class="page-wrapper introducer l-pb-80">
			<div class="introducer__content">
				<h1 class="introducer__title">{{ $t('prospectsCrm.title') }}</h1>
				<p class="introducer__text" v-html="$t('prospectsCrm.text')"></p>
			</div>
			<div><img :src="require('@/' + $t('prospectsCrm.image'))" alt="" class="introducer__image introducer__image--small" /></div>
		</div>				
		<div class="jumbotron jumbotron--image jumbotron--large" :style="'background-image: url(' + require('@/' + $t('jumbotronImage')) + ')'">
			<section class="section-wrapper section-wrapper--large">
				<h1 class="title title--white title--bold">{{ $t('jumbotronTitle') }}</h1>
				<h2 class="subtitle title--white">{{ $t('jumbotronSubtitle') }}</h2>
				<a href="https://prospectsinc.zendesk.com/" target="_blank" class="button button--large button--redFade">{{ $t('general.learnMore') }}</a>
			</section>
		</div>
  </div>
</template>


<script>
import videoMixin from '@/video-mixin.js'
import Showcaser from '@/components/utils/Showcaser.vue'

export default {
	components: { Showcaser },
  	mixins: [videoMixin],
	mounted () {

	},

	data () {
		return {

		}
	},
	i18n: {
		messages: {
			'en-CA': {
				introducerImage: "assets/pages/mobile/introducer-en-ca.jpg",
				introducerText1: "The Most ADVANCED Mobile Real Estate App for Agents",
				introducerSubtitle: "Used by 950k+ Real Estate Agents",
				introducerText2: "@:(mobileName) gives you the tools you need to stay connected to critical listing data and client activities while you're on the go.",
				availabilityCondition: "*Available for download in participating markets.",
				videoYoutubeId: "LbRvj_jju7A",
				jumbotronImage: "assets/jumbotron-red.jpg",
				jumbotronTitle: "Learning Resources",
				jumbotronSubtitle: "Maximize the power of @:(mobileName). We have videos, webinars, and guides to help you.",
				keyFeatures: {
					title: "A Premium Mobile Solution",
					subtitle: "<span class='u-weight-bold'>@:(mobileName) is an extension of your MLS</span> and so intuitively designed, you'll be using it like a Pro the first time you log in.",
					items: [
						{ title: 'Smart Searches', text: 'by neighbourhood, schools and more', imagePath: 'assets/pages/mobile/showcase-searches-en-ca.jpg' }, 
						{ title: 'InstaView', text: 'point and tap for details', imagePath: 'assets/pages/mobile/showcase-instaview-en-ca.jpg' }, 
						{ title: 'Live Market Stats', text: 'real-time insights', imagePath: 'assets/pages/mobile/showcase-stats-en-ca.jpg' }, 
						{ title: 'Comparables', text: 'nearby actives and solds in seconds', imagePath: 'assets/pages/mobile/showcase-comparables-en-ca.jpg' }, 
						{ title: 'Hotsheet', text: 'new listings, price reductions, solds', imagePath: 'assets/pages/mobile/showcase-hotsheet-en-ca.jpg' }, 
						{ title: 'Facebook Publishing', text: 'automatic listing posts', imagePath: 'assets/pages/mobile/showcase-facebook-en-ca.jpg' }
					]
				},
				integrations: {
					title: "Integrated with Matrix™ and OneHome™",
					text: "<span class='u-weight-bold'>Seamless integrations ensure your most important client data is always at your fingertips.</span> Contacts, favourites, sent listings, carts, and saved searches automatically sync with @:(mobileName).",
					image: "assets/pages/mobile/matrix-integrations-en-ca.jpg"
				},
				collaboration: {
					title: "Collaborate Like Never Before",
					text: "<span class='u-weight-bold'>Create your own branded app and give your clients access to ALL listings in your market, straight from your MLS!</span> Easily share suggested listings and track client activities and favourites in @:(mobileName).",
					image: "assets/pages/mobile/collaboration-en-ca.jpg"
				},
				prospectsCrm: {
					title: "Integrated with Prospects CRM",
					text: "<span class='u-weight-bold'>@:(mobileName) is not just an extension of Matrix™.  It’s an extension of Prospects CRM too!</span> Prospects CRM is also built by Prospects Software (us!) and available in many markets alongside @:(mobileName). The seamless integrations between @:(mobileName) and Prospects CRM save you tons of time. All your client info and activities from your CRM are tracked and at your fingertips with @:(mobileName).",
					image: "assets/pages/mobile/crm-en-ca.jpg"
				},
			},
			'en-US': { 
				introducerImage: "assets/pages/mobile/introducer-en-us.jpg",
				introducerText1: "The Most ADVANCED Mobile MLS App for Agents",
				introducerText2: "@:(mobileName) gives you the tools you need to stay connected to critical listing data, tax data, and client activities while you're on the go.",
				videoYoutubeId: "zL1gaIvVuQM",
				jumbotronImage: "assets/jumbotron-blue.jpg",
				keyFeatures: {
					title: "A Premium Mobile Solution",
					subtitle: "<span class='u-weight-bold'>@:(mobileName) is not an ad platform.</span> It’s an extension of your MLS and so intuitively designed, you’ll be using it like a Pro the first time you log in. ",
					items: [
						{ title: 'Smart Searches', text: 'by neighborhood, schools and more', imagePath: 'assets/pages/mobile/showcase-searches-en-us.jpg' }, 
						{ title: 'InstaView', text: 'point and tap for details', imagePath: 'assets/pages/mobile/showcase-instaview-en-us.jpg' }, 
						{ title: 'Live Market Stats', text: 'real-time insights', imagePath: 'assets/pages/mobile/showcase-stats-en-us.jpg' }, 
						{ title: 'Comparables', text: 'nearby actives and solds in seconds', imagePath: 'assets/pages/mobile/showcase-comparables-en-us.jpg' }, 
						{ title: 'Hotsheet', text: 'new listings, price reductions, solds', imagePath: 'assets/pages/mobile/showcase-hotsheet-en-us.jpg' }, 
						{ title: 'Facebook Publishing', text: 'automatic listing posts', imagePath: 'assets/pages/mobile/showcase-facebook-en-us.jpg' }
					]
				},
				integrations: {
					title: "Integrated with Matrix™, OneHome™ and Realist®",
					text: "<span class='u-weight-bold'>Seamless integrations ensure your most important client data is always at your fingertips.</span> Contacts, favorites, sent listings, carts, and saved searches automatically sync with MLS-Touch. CoreLogic property insights are also just a tap away including parcel boundary lines, tax and ownership/occupancy details, property Sell Scores, AVM data, flood zone data, and much more.",
					image: "assets/pages/mobile/matrix-integrations-en-us.jpg"
				},
				collaboration: {
					image: "assets/pages/mobile/collaboration-en-us.jpg"
				},
				prospectsCrm: {
					image: "assets/pages/mobile/crm-en-us.jpg"
				},
			},
			'fr-CA': { 
				introducerImage: "assets/pages/mobile/introducer-fr-ca.jpg",
				introducerText1: "L'application mobile la plus AVANCÉE conçue pour les courtiers immobiliers",
				introducerSubtitle: "Utilisée par plus de 700 000 courtiers",
				introducerText2: "@:(mobileName) vous offre les outils dont vous avez besoin pour être branché sur les données critiques des inscriptions et les activités de vos clients pendant que vous êtes sur la route.  ",
				availabilityCondition: "* Disponible dans les marchés participants.",
				videoYoutubeId: "LbRvj_jju7A",
				jumbotronTitle: "Ressources d'apprentissage",
				jumbotronSubtitle: "Maximisez la puissance de @:(mobileName). Nous avons des vidéos, des webinaires et des guides pour vous aider.",
				keyFeatures: {
					title: "Une solution mobile supérieure",
					subtitle: "<span class='u-weight-bold'>@:(mobileName) est une extension de Centris / Matrix™ </span> et est conçue de façon si intuitive que vous l'utiliserez comme un pro dès votre première connexion.",
					items: [
						{ title: 'Recherches intelligentes', text: 'par quartier, écoles, et plus encore', imagePath: 'assets/pages/mobile/showcase-searches-fr-ca.jpg' }, 
						{ title: 'Façade', text: 'pointez et tappez pour obtenir les détails', imagePath: 'assets/pages/mobile/showcase-instaview-fr-ca.jpg' }, 
						{ title: 'Statistiques du marché instantanées', text: 'informations en temps réel', imagePath: 'assets/pages/mobile/showcase-stats-fr-ca.jpg' }, 
						{ title: 'Comparables', text: 'actifs et vendus à proximité en quelques secondes', imagePath: 'assets/pages/mobile/showcase-comparables-fr-ca.jpg' }, 
						{ title: 'Nouveautés', text: 'nouvelles inscriptions, réductions de prix, ventes', imagePath: 'assets/pages/mobile/showcase-hotsheet-fr-ca.jpg' }, 
						{ title: 'Publication Facebook', text: 'publication automatique de vos inscriptions', imagePath: 'assets/pages/mobile/showcase-facebook-fr-ca.jpg' }
					]
				},
				integrations: {
					title: "Intégré à Matrix™ et au portail client",
					text: "<span class='u-weight-bold'>Des intégrations transparentes garantissent que les données les plus importantes sur vos clients sont toujours à portée de main. </span> Les contacts, les favoris, les inscriptions envoyées, les paniers et les recherches enregistrées se synchronisent automatiquement avec @:(mobileName).",
					image: "assets/pages/mobile/matrix-integrations-fr-ca.jpg"
				},
				collaboration: {
					title: "Votre image de marque au premier plan",
					text: "<span class='u-weight-bold'>Configurez votre logo et les couleurs de votre choix en quelques clics seulement.</span> Envoyez plusieurs inscriptions à la fois avec votre image de marque au premier plan.",
					image: "assets/pages/mobile/collaboration-fr-ca.jpg"
				},
				prospectsCrm: {
					title: "Intégré avec Prospects CRM",
					text: "<span class='u-weight-bold'>@:(mobileName) n'est pas seulement une extension de Matrix™. C'est aussi une extension de Prospects CRM! </span> Prospects CRM est également conçu par Logiciels Prospects (nous !) et disponible dans de nombreux marchés parallèlement à @:(mobileName). Les intégrations transparentes entre @:(mobileName) et Prospects CRM vous font gagner beaucoup de temps. Les informations sur vos clients de votre CRM sont à portée de main avec @:(mobileName).",
					image: "assets/pages/mobile/crm-fr-ca.jpg"
				},
			},
		}
	},
	computed: {

	},
	methods: {

	}
};
</script>

<style scoped>
	.introducer { display: flex; align-items: center; }
	.introducer--reversed { flex-direction: row-reverse; }
	.introducer > * { flex: 1; }
	.introducer > *:first-child { margin-right: 40px; }
	.introducer__title { font-size: 3.5rem; font-weight: 700; padding: 20px 0; }
	.introducer__subtitle { font-size: 1.75rem; font-weight: 400; font-style: italic; padding-bottom: 20px; }
	.introducer__text { line-height: 1.5; color: #666; }
	.introducer__image { max-height: 650px; max-width: 100%; }
	.introducer__image--small { max-height: 400px; }
	.introducer__applications { display: flex; }
	.introducer__application { margin-right: 10px; }
	.introducer__conditions { margin-top: 30px; color: grey; font-size: 1.2rem; }
	.play { display: flex; align-items: center; font-weight: 700; margin: 40px 0; }
	.play svg { height: 40px; margin-right: 10px; }
	.showcaser-title { font-size: 2.7rem; font-weight: 700; }
	.showcase-text { padding: 10px 0; line-height: 1.5; color: #666; }

	@media (max-width: 768px) {
		.introducer { flex-direction: column; justify-content: center; text-align: center; }
		.introducer > *:first-child { margin-right: 0; }
		.introducer__content { display: flex; flex-direction: column; align-items: center; }
		.play { margin: 20px 0; }
	}
</style>
